export default "__VITE_ASSET__CigP4YEY__"